import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps }) => {
  const steps = [
    { id: 1, label: 'Business Details', icon: 'Building' },
    { id: 2, label: 'Specializations', icon: 'MapPin' },
    { id: 3, label: 'Payment Setup', icon: 'CreditCard' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-8">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => {
          const isCompleted = step?.id < currentStep;
          const isCurrent = step?.id === currentStep;
          const isUpcoming = step?.id > currentStep;

          return (
            <React.Fragment key={step?.id}>
              <div className="flex flex-col items-center">
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${
                    isCompleted
                      ? 'bg-success border-success text-success-foreground'
                      : isCurrent
                      ? 'bg-primary border-primary text-primary-foreground'
                      : 'bg-background border-border text-muted-foreground'
                  }`}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={20} />
                  ) : (
                    <Icon name={step?.icon} size={20} />
                  )}
                </div>
                <div className="mt-3 text-center">
                  <div
                    className={`text-sm font-medium ${
                      isCurrent ? 'text-primary' : isCompleted ? 'text-success' : 'text-muted-foreground'
                    }`}
                  >
                    Step {step?.id}
                  </div>
                  <div
                    className={`text-xs mt-1 ${
                      isCurrent ? 'text-foreground' : isCompleted ? 'text-success' : 'text-muted-foreground'
                    }`}
                  >
                    {step?.label}
                  </div>
                </div>
              </div>
              {index < steps?.length - 1 && (
                <div className="flex-1 mx-4">
                  <div
                    className={`h-0.5 transition-all duration-300 ${
                      step?.id < currentStep ? 'bg-success' : 'bg-border'
                    }`}
                  ></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="mt-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-muted-foreground">Progress</span>
          <span className="text-sm font-medium text-foreground">
            {Math.round(((currentStep - 1) / (totalSteps - 1)) * 100)}%
          </span>
        </div>
        <div className="w-full bg-border rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full transition-all duration-500"
            style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;